var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-page",style:({ height: _vm.height })},[_c('div',{staticClass:"progress-wrapper"},[_c('el-progress',{attrs:{"type":"circle","percentage":_vm.progress}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }